import { ChangeDetectionStrategy, Component, OnInit, ViewChild, inject, signal } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { LoaderComponent, ModalComponent } from 'mbs-ui-kit';
import { StorageAccountsService } from 'mbs-ui-shared@services/storage-accounts/storage-accounts.service';
import { finalize, take } from 'rxjs';

@Component({
  selector: 'mbs-minimum-required-permissions-modal',
  templateUrl: './minimum-required-permissions-modal.component.html',
  styleUrls: ['./minimum-required-permissions-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [I18NextPipe, LoaderComponent, ModalComponent]
})
export class MinimumRequiredPermissionsModalComponent implements OnInit {
  private storageAccountsService = inject(StorageAccountsService);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public readonly loading = signal(true);
  public readonly requiredPermissions = signal('');

  ngOnInit(): void {
    this.storageAccountsService
      .getMinimumRequiredPermissions()
      .pipe(
        take(1),
        finalize(() => this.loading.set(false))
      )
      .subscribe((permissions) =>
        this.requiredPermissions.set(typeof permissions === 'string' ? permissions : JSON.stringify(permissions, null, 2))
      );
  }
}
